export const FETCH_SITE_CLOSURE_REQUEST_DATA_SUCCEED =
  'src/patientApp/SiteClosureRequest/FETCH_SITE_CLOSURE_REQUEST_DATA_SUCCEED';
export const DOWNLOAD_SITE_CLOSURE_REQUEST_SUCCEED =
  'src/patientApp/SiteClosureRequest/DOWNLOAD_SITE_CLOSURE_REQUEST_SUCCEED';
export const RESEND_PIN_REQUEST_SUCCEED =
  'src/patientApp/SiteClosureRequest/RESEND_PIN_REQUEST_SUCCEED';
